"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapCalculationInputToFaunaCalculationInput = exports.mapCalculationFieldsToFaunaCalucationInput = exports.mapCalculationInputToFaunaCreateInput = void 0;
const vehicle_1 = require("./vehicle");
const financing_1 = require("./financing");
const utils_1 = require("../../utils");
const mapCalculationInputToFaunaCreateInput = (input) => {
    const create = (0, exports.mapCalculationInputToFaunaCalculationInput)(input);
    return { create: [create] };
};
exports.mapCalculationInputToFaunaCreateInput = mapCalculationInputToFaunaCreateInput;
const mapComments = (input) => {
    if (!!input.comments) {
        return {
            comments: {
                create: input.comments.map((comment) => {
                    var _a;
                    return {
                        text: comment.text,
                        userId: (_a = comment.userId) !== null && _a !== void 0 ? _a : '',
                    };
                }),
            },
        };
    }
    return {};
};
const mapCalculationFieldsToFaunaCalucationInput = (input) => {
    return utils_1.FaunaMapper.mapFaunaInput(Object.assign({}, mapComments(input)));
};
exports.mapCalculationFieldsToFaunaCalucationInput = mapCalculationFieldsToFaunaCalucationInput;
const mapCalculationInputToFaunaCalculationInput = (input) => {
    const mappedInput = utils_1.FaunaMapper.mapFaunaInput(input, ['id', 'calculationId', 'timestamp']);
    return Object.assign(Object.assign({}, mappedInput), { accessories: (mappedInput === null || mappedInput === void 0 ? void 0 : mappedInput.accessories) ? { create: mappedInput.accessories } : undefined, comments: (mappedInput === null || mappedInput === void 0 ? void 0 : mappedInput.comments) ? { create: mappedInput.comments } : undefined, customer: (mappedInput === null || mappedInput === void 0 ? void 0 : mappedInput.customer)
            ? { create: utils_1.EnumMapper.mapEnumsToStringRecursively(mappedInput.customer) }
            : undefined, financing: (mappedInput === null || mappedInput === void 0 ? void 0 : mappedInput.financing) ? (0, financing_1.mapFinancingInputToFaunaCreateInput)(mappedInput.financing) : undefined, history: (mappedInput === null || mappedInput === void 0 ? void 0 : mappedInput.history) ? mappedInput.history.map((financing) => financing.id) : undefined, order: (mappedInput === null || mappedInput === void 0 ? void 0 : mappedInput.order) ? {} : undefined, previousOrder: (mappedInput === null || mappedInput === void 0 ? void 0 : mappedInput.previousOrder) ? {} : undefined, reference: (mappedInput === null || mappedInput === void 0 ? void 0 : mappedInput.reference) ? { create: mappedInput.reference } : undefined, vehicles: (mappedInput === null || mappedInput === void 0 ? void 0 : mappedInput.vehicles) ? (0, vehicle_1.mapVehicleInputToFaunaCreateInput)(mappedInput.vehicles) : undefined });
};
exports.mapCalculationInputToFaunaCalculationInput = mapCalculationInputToFaunaCalculationInput;
//# sourceMappingURL=calculation.js.map